<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.amount"
          name="Amounts"
          :label="$t('Amounts')"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Amounts')"
          >{{ errors.first("Amounts") }}</span
        >
        <div>
          <label class="vs-select--label">{{ $t("OriginParties") }}</label>
          <treeselect
            v-model="model.originParty"
            name="stockid"
            :multiple="false"
            :placeholder="$t('Search')"
            :async="true"
            :load-options="loadOptions"
            :class="{ 'is-invalid': errors.has('stockid') }"
            v-validate="'required'"
            @select="onStockSelected"
          />
        </div>
        <div class="mt-5">
          <span>{{ $t("OriginAccount") }}</span>
          <v-select
            label="title"
            :options="allAccounts"
            name="Account"
            v-model="model.originAccount"
            :clearable="false"
            dir="rtl"
          >
          </v-select>
        </div>
        <div class="mt-5">
          <label class="vs-select--label">{{ $t("DestinationParties") }}</label>
          <treeselect
            v-model="model.destinationParty"
            name="destinationParty"
            :multiple="false"
            :placeholder="$t('Search')"
            :async="true"
            :load-options="loadOptionsDestination"
            :class="{ 'is-invalid': errors.has('destinationParty') }"
            v-validate="'required'"
            @select="onStockSelectedDestination"
          />
        </div>
        <div class="mt-5">
          <span>{{ $t("DestinationAccount") }}</span>
          <v-select
            label="title"
            :options="allAccountsDestination"
            name="Account"
            v-model="model.accountDestination"
            :clearable="false"
            dir="rtl"
          >
          </v-select>
        </div>
        <vs-button
          type="filled"
          class="float-right mb-4 mt-5"
          :disabled="!model.accountDestination || !model.destinationParty || !model.originAccount || !model.originParty ||!model.amount"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import vSelect from "@/components/CustomVSelect.vue";

const dict = {
  custom: {
    Amounts: {
      required: "لطفا مقدار را وارد نمایید.",
    },  
  },
};

Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  components: {
    Treeselect,
    "v-select": vSelect,
  },
  data() {
    return {
      AccountTitle: "",
      popupTitle: "",
      disabled: false,
      allAccounts: [],
      allAccountsDestination: [],
      party: 0,
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createDeposit: "pettyCash/createDeposit",
      fetchPettyCashAccount: "pettyCash/fetchAccount",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchPettyCashAccount(searchQuery).then((r) => {
              const options = [];
              r.data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                  accountInfoQueries: element.accountInfoQueries,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onStockSelected(data) {
      data.accountInfoQueries.forEach(element=>{
        var x ={
          title:element.accountTitle,
          id: element.accountId
        }
        this.allAccounts.push(x)
      })
      // this.allAccounts = data.accountInfoQueries;
      this.party = data.id;
    },
    loadOptionsDestination({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchPettyCashAccount(searchQuery).then((r) => {
              const options = [];
              r.data.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.name,
                  accountInfoQueries: element.accountInfoQueries,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onStockSelectedDestination(data) {
      data.accountInfoQueries.forEach(element=>{
        var x ={
          title:element.accountTitle,
          id: element.accountId
        }
        this.allAccountsDestination.push(x)
      })
      this.party = data.id;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var payload={
            amount:this.model.amount,
            sourceAccountInfo:{
              accountId:this.model.originAccount.id,
              partyId:this.model.originParty,
            },
            destinationAccountInfo:{
              accountId:this.model.accountDestination.id,
              partyId:this.model.destinationParty,
            }

          }
            this.createDeposit(payload).then(() => {

              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
          else{

          }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "EditAccount";
        else this.popupTitle = "CreateReceipts";
      }
      this.$validator.reset();
    },
  },
};
</script>
<style>
.theme-dark .vue-treeselect__control{
  background: #202020;
}</style>